
<template>
  <div>
    <b-button-toolbar 
      aria-label="Toolbar with button groups and input groups" 
      class="mb-3"
    >
      <b-input-group 
        append="index" 
        prepend="toepassen"
      >
        <b-form-input 
          v-model="index" 
          placeholder="..." 
          required 
          type="number" 
          debounce="500"
        />
      </b-input-group>
    </b-button-toolbar>
    <b-table
      id="dataTableTeherhalen"
      ref="overzichtteherhalen"
      :fields="fields"
      :items="herhaalfacturen"
      bordered
      dark
      show-empty
      primary-key="RemoteId"
    >
      <template #empty>
        <h4>Geen facturen</h4>
      </template>
      <template #table-colgroup="scope">
        <col
          v-for="field in scope.fields"
          :key="field.key"
          :style="{ width: (field.width || 180) + 'px' }"
        >
      </template>

      <template slot="table-busy">
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle" />
          <strong>Laden...</strong>
        </div>
      </template>

      <template #cell(Factuurnummer)="props">
        <b-button 
          class="btn-sm pull-right" 
          disabled 
          @click="props.toggleDetails"
        >
          {{ props.item.Factuurregels.length }}&nbsp;
          <i
            :class="props.detailsShowing ? 'fa-caret-up' : 'fa-caret-down'"
            class="fa"
          />
        </b-button>

        <div v-if="props.item.Factuurnummer">
          {{ props.item.Factuurnummer }}
        </div>
        <div v-else>
          <b-badge variant="warning">
            concept
          </b-badge>
        </div>
      </template>

      <template slot="empty">
        geen facturen voor jaar
      </template>

      <template #cell(Datum)="props">
        {{ props.item.Datum | formatDateTime( 'DD-MM-YYYY') }}
        <i
          v-if="props.item.Herhalen"
          class="fa fa-refresh"
        />
      </template>

      <template #cell(Relatie)="props">
        {{ props.item.Relatie.Naam }}
      </template>

      <template #cell(VerzendenNaar)="props">
        {{ props.item.VerzendenNaar }}
        <i 
          v-if="props.item.AutomatischUitsturen" 
          class="fa fa-send"
        />
      </template>
      <template #cell(AutomatischUitsturen)="props">
        <b-form-checkbox
          v-model="props.item.AutomatischUitsturen"
        />
      </template>

      <template
        #cell(Totaal)="props"
        class="pull-right"
      >
        {{ totaal(props.item) | formatNumber() }}
      </template>

      <template #cell(Bewerken)="regel">
        <b-button
          :disabled="regel.item.IsHerhalingVan.HerhalingIs != null"
          @click="opslaanFactuur(regel.item)"
        >
          Aanmaken
        </b-button>
      </template>

      <template #row-details="props">
        {{ props }}
      </template>
    </b-table>
  </div>
</template>

<script>
import { facturatieMixin } from "@/mixins/facturatieMixin";
export default {
  mixins: [facturatieMixin],
  props: {
    facturen: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      index: 1.05,
      fields: [
        { key: "Factuurnummer", sortable: true, width: 100 },
        { key: "Datum", sortable: true, width: 100 },
        { key: "Relatie", sortable: true },
        "Onderwerp",
        
        { key: "VerzendenNaar", label: "E-mail" },
        { key: "AutomatischUitsturen",label: "Uitsturen" },
        { key: "Totaal", width: 80 },
        { key: "Bewerken", width: 250 }
      ]
    };
  },
  computed: {
    herhaalfacturen() {
      var ften = [];
      var vm = this;
      this.facturen.forEach(f => ften.push(vm.repeatFactuur(f)));

      return ften;
    }
  },
  methods: {
    opslaanFactuur: function(factuur) {
      this.$http
        .post(
          "/facturen/" + factuur.Prijspeiljaar,
          {
            factuur: factuur,
            orgineelId: factuur.orgineelId
          },
          
        )
        .then(function(response) {
          console.log(response.data);
          if (response.data.resultaat.RemoteId) {
           factuur.IsHerhalingVan.HerhalingIs = response.data.resultaat;
          } else {
            console.dir(response.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
};
</script>